import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import Option from './Option';
import { emptyFn } from '../../utils/helper';
import { consumeTheme } from '../../utils/theme';
import { i18n } from '../../common/locale';
import { getElementsInChildren } from '../../utils/children';
import ActionSheet from '../ActionSheet';
var OptionElementType = (h(Option, null)).type;
var Select = (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentValue: _this.props.defaultValue,
            visible: false,
        };
        _this.handleChange = function (value) {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ currentValue: value, visible: false });
            _this.props.onChange(value);
        };
        _this.handleClick = function () {
            if (_this.state.visible) {
                return;
            }
            var options = _this.getChildrenOptions().map(function (_a) {
                var props = _a.props;
                return ({
                    id: props.value,
                    disabled: props.disabled,
                    title: props.children,
                    style: props.style,
                    className: props.className,
                    titleStyle: props.titleStyle,
                    titleClassName: props.titleClassName,
                });
            });
            var currentValue = _this.state.currentValue;
            var _a = _this.props, actionSheetClassName = _a.actionSheetClassName, actionSheetStyle = _a.actionSheetStyle;
            ActionSheet.show({
                options: options,
                selectedIds: currentValue ? [currentValue] : [],
                onClickAction: _this.handleChange,
                onCancel: function () { return _this.setState({ visible: false }); },
                className: actionSheetClassName,
                style: actionSheetStyle,
            });
            _this.setState({ visible: true });
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c;
            var _d = _this.props, prefixCls = _d.prefixCls, className = _d.className, style = _d.style, disabled = _d.disabled, showArrow = _d.showArrow, placeholder = _d.placeholder;
            var _e = _this.state, currentValue = _e.currentValue, visible = _e.visible;
            var selectClasses = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-disabled"] = disabled,
                _a[prefixCls + "-visible"] = visible,
                _a));
            var selectedText = (_c = _this.getChildrenOptions().find(function (elem) { return elem.props.value === currentValue; })) === null || _c === void 0 ? void 0 : _c.props.children;
            var textClasses = classNames(prefixCls + "-text", (_b = {},
                _b[prefixCls + "-placeholder"] = !selectedText,
                _b));
            return (h("div", { className: selectClasses, style: style, onClick: _this.handleClick },
                h("div", { className: textClasses }, selectedText || placeholder),
                showArrow ? h("div", { className: classNames(prefixCls + "-arrow") }) : null));
        };
        return _this;
    }
    Select.getDerivedStateFromProps = function (props, state) {
        if (props.value !== undefined) {
            return { currentValue: props.value };
        }
        return null;
    };
    Select.prototype.getChildrenOptions = function () {
        var children = this.props.children;
        return getElementsInChildren(children, OptionElementType);
    };
    Select.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Select;
}(React.Component));
export default Select;
Select.defaultProps = {
    prefixCls: 'dui-m-select',
    onChange: emptyFn,
    showArrow: true,
    disabled: false,
    placeholder: i18n('select'),
    defaultValue: ''
};
